import { render, staticRenderFns } from "./PageOverallSubmissionDenied.vue?vue&type=template&id=756f701d&scoped=true&"
import script from "./PageOverallSubmissionDenied.vue?vue&type=script&lang=js&"
export * from "./PageOverallSubmissionDenied.vue?vue&type=script&lang=js&"
import style0 from "./PageOverallSubmissionDenied.vue?vue&type=style&index=0&id=756f701d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f701d",
  null
  
)

export default component.exports